import React from "react";
// node.js library that concatenates classes (strings)
import classnames from "classnames";

import {
  Button,
  Card,
  CardHeader,
  CardBody,
  NavItem,
  NavLink,
  Nav,
  Progress,
  Table,
  Container,
  Row,
  Col
} from "reactstrap";

import GenericHeader from "components/Headers/GenericHeader.js";
// import Spinner from "views/examples/Spinner.js";
import Moment from "moment";
import 'moment/locale/el';

class Documents extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      error: null,
      activeNav: 1,
      isLoaded: false,
      files: []
    };
  }

  componentDidMount() {
    fetch(process.env.REACT_APP_API_LINK + "/api/files/bin/all/", {
      method: 'get',
      headers: new Headers({
        'Authorization': 'Bearer ' + localStorage.getItem('token'),
        'Content-Type': 'application/x-www-form-urlencoded'
      })
    })
      .then(res => res.json())
      .then(
        (result) => {
          this.setState({
            isLoaded: true,
            files: result,
          });
        },
        (error) => {
          this.setState({
            isLoaded: true,
            error
          });
        }
      );
  }

  restoreFile(instance_id) {
    fetch(process.env.REACT_APP_API_LINK + "/api/files/restore/" + instance_id + "/", {
      method: 'POST',
      headers: new Headers({
        'Authorization': 'Bearer ' + localStorage.getItem('token'),
        'Content-Type': 'application/x-www-form-urlencoded'
      })
    })
      .then(res => res.json())
      .then(
        (result) => {
          window.location.reload(false);
        }
      );
  }

  render() {
    return (
      <>
        <GenericHeader />
        {/* Page content */}
        <Container className="mt--7" fluid>
          <Row className="mt-5">
            <Col className="mb-5 mb-xl-0" xl="12">
              <Card className="shadow">
                <CardHeader className="border-0">
                  <Row className="align-items-center">
                    <div className="col">
                      <h3 className="mb-0">Διεγραμμένα Αρχεία</h3>
                    </div>
                  </Row>
                </CardHeader>
                <Table className="align-items-center table-flush" responsive>
                  <thead className="thead-light">
                    <tr>
                      <th scope="col">Ονομα Αρχειου</th>
                      <th scope="col">Ημερομηνια Υποβολης</th>
                      <th scope="col">Χρηστης</th>
                      <th scope="col">Ενεργειες</th>
                    </tr>
                  </thead>
                  <tbody>
                    {
                      this.state.files.map((dynamicData) =>
                        <tr>
                          <th scope="row"> {dynamicData.FileName}</th>
                          <td> {dynamicData.UploadDate} </td>
                          <td>{dynamicData.UserId}</td>
                          <td><Button
                            color="primary"
                            href={dynamicData.Link}
                            size="sm"
                          >
                            Προβολή Αρχείου
                          </Button>
                            <Button
                              color="danger"
                              href={"/admin/details/" + dynamicData.InstanceId}
                              size="sm"
                            >
                              Προβολή Αίτησης
                            </Button>
                            <Button
                              color="success"
                              onClick={() => this.restoreFile(dynamicData.InstanceId)}
                              size="sm"
                            >
                              Επαναφορά
                            </Button></td>
                        </tr>
                      )
                    }
                  </tbody>
                </Table>
              </Card>
            </Col>
          </Row>
        </Container>
      </>
    );
  }
}

export default Documents;
